export enum DataTestStatus {
  NotStarted = 'not_started',
  Pending = 'pending',
  Ready = 'ready',
  Failed = 'failed',
  NoTestsConfigured = 'no_tests_configured',
}
